module.exports = __webpack_public_path__ + "img/icon_img01.1e7d8a16.png";